<template>
  <div class="basic_login_register height_fill" :style="{
      height: pc_widgets_infor.height + 'px'
    }" >
    <!-- <img  class="mb_icon" src="../../../static/image/langs.png" :style="imgStyle" v-if="!isPc" @click="headerLoginShow"> -->
    <i class="fa fa-user-circle mb_icon" v-if="isInMobileHeader && false" @click="headerLoginShow" :style="imgStyle"></i>
    <div class="header-login" :class="{'header-login-mb': isInMobileHeader}" ref="headerLogin" :style="login_content_style">
      <div v-if="$store.state.myRender.common.setting.shoppingCart" class="login-list">
        <img src="https://sitecdn.71360.com/static/txys-001/assets/wmsite-xys-img/shopping/shop.png" alt="">
        Inquiry Cart</div>
      <div v-if="$store.state.myRender.common.setting.loginRegister" class="login-list sign_in"><img src="https://sitecdn.71360.com/static/txys-001/assets/wmsite-xys-img/shopping/user.png" alt="">Sign in</div>
    </div>
     <!-- 手机放置一个头部 icon 用来点击显示下方的登录 注册 会员中心 PC端的话 应该不显示这个icon 会员中心 登录注册 放在右侧显示   手机菜单这边 还要一个 正三角-->
  </div>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

export default {
  name:"basic_loginregister",
  data(){
    return{
    }
  },
  props: {
    module: {
      type: Object,
      default: () => {}
    },
    isInMobileHeader: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    theme_color () {
      return this.$store.state.myRender.common.theme_color
    },
    active_color() {
      return ({
        color: this.theme_color
      })
    },
    login_content_style(){
      let style = {}
      if(this.$store.state.app.view_pattern === 'mb') {
        let num = 0; // 这个是为了 右侧放置登录注册头部的东西
        style = {
          left: this.$store.state.myRender.common.mb_header_nav_position == 'left' ? 'auto' : `${num}px`,
          right: this.$store.state.myRender.common.mb_header_nav_position == 'left' ? `${num}px` : 'auto',
        }
      }
      return style
    },
    imgStyle() {
      let style = {}
      if(this.$store.state.app.view_pattern === 'mb') {
        let num = 20; // 这个是为了 右侧放置登录注册头部的东西
        style = {
          left: this.$store.state.myRender.common.mb_header_nav_position == 'left' ? 'auto' : `${num}px`,
          right: this.$store.state.myRender.common.mb_header_nav_position == 'left' ? `${num}px` : 'auto',
        }
      }
      return style
    },
    isPc() {
      return this.$store.state.app.view_pattern =='pc'
    },
    list_link() {
      return this.listArr.list_link // .filter(item => item.id !== this.$route.name)
    },
    listArr(){
      return this.module.data.listArr
    },
    pc_widgets_infor() {
       return this.module.data.pc_widgets_infor
    },
  },
  created() {
    if(!this.pc_widgets_infor.height  ) {
      this.$set(this.module.data, 'pc_widgets_infor', {height: 80})
     // this.$set(this.pc_widgets_infor, 'height', 80)
    }
  },
  mounted() {
  },
  methods: {
    headerLoginShow() {
      let dom = this.$refs.headerLogin;
      // dom.style.display = 'block'
      if(dom.style.display === 'block') {
        dom.style.display = 'none'
      } else dom.style.display = 'block'
    },
    goLink(path){  // 路由 发生变化 link  这个地方要判断一下 这个更改是否发生变化
      if(this.$store.state.app.is_change) {
         this.$confirm(i18n.t('components_my_anchor_set_index_2235'), '', {
          confirmButtonText: i18n.t('components_my_anchor_set_index_2236'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        }).then(() => {
          this.$store.commit('app/SET_is_change', false);
          this.templet.p_save(()=> {
            this.goLink(path)
          }); // this.goLink(path)
        })
        .catch(() => {
        });
      } else this.$router.push(path)
    }
  },
};
</script>

<style scoped lang="scss">
.basic_login_register{
  .mb_icon {
      width: 25px;
      height: 25px;
      position: absolute;
      right: 20px;
      top: 12px;
      z-index: 1000;
      font-size:24px;
      color:#ACC9EC;
  }
  .header-login{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height:100%;
    .login-list{
      // height: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      // line-height: 22px;
      line-height:1;
      word-wrap: break-word;
      word-break: break-all;
      cursor: pointer;
      display: flex;
      align-items: center;
      &.sign_in{
        margin-left: 20px;
      }
      img{
        margin-right: 4px;
      }
    }
  }
  .header-login-mb{
    position: absolute;
    width: 140px;
    padding: 0 8px;
    text-align: left;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #C5C5C5;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    display:none;
    // right:0;
    right:0px;
    height:auto;
    margin-top:50px;
    top:0;
    .login-list{
      margin-left:0;
      /* height: 24px;
      line-height: 24px; */
      margin:8px 0;
      font-size:13px;
      text-align:center;
      color: #8A929E;
      word-wrap: break-word;
      word-break: break-all;
    }
    .triangle{
      width: 12px;
      height: 12px;
      background: #fff;
      position: absolute;
      left: 50%;
      transform-origin: center center;
      box-sizing: border-box;
      box-shadow: inherit;
      border: 1px solid #ebebeb;
      border-left: 0;
      border-bottom: 0;
      top: 0;
      transform: translate(-50%,-50%) rotate(-45deg);
    }
  }

}
</style>




// WEBPACK FOOTER //
// src/widgets/basic_loginregister/index.vue